import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

export const Container = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
`;

export const IconContainer = styled.div`
  svg {
    inline-size: 45px;
    block-size: 45px;
  }

  ${theme.breakpoints.up("tablet")} {
    svg {
      inline-size: 32px;
      block-size: 32px;
    }
  }
`;
